import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="border-t border-ink-line bg-ink-soft px-5 py-20 md:py-28" aria-labelledby="faq-title" data-id="element-71" data-mp="1lc1zxc2r31qn">
      <div className="mx-auto grid max-w-6xl gap-12 md:grid-cols-[1fr_1.6fr]" data-id="element-72" data-mp="1gal1dn7qnrd8">
        <h2 id="faq-title" className="font-display text-4xl uppercase leading-none text-cream md:text-6xl" data-id="element-73" data-mp="2dzxuob8rejks">
          Questions <span className="text-gold" data-id="element-74" data-mp="28za39ogmc0q1">fréquentes</span>
        </h2>
        <div className="divide-y divide-ink-line border-y border-ink-line" data-id="element-75" data-mp="240yu7fy5du8v">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.question} data-id="element-76" data-mp="snmoezitv1k2" data-mpi={i}>
                <h3 data-id="element-77" data-mp="soo9zxxgz6g1">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 py-5 text-left font-serif text-lg font-semibold text-cream transition-colors duration-150 ease-out hover:text-gold-soft focus:outline-none focus-visible:text-gold-soft" data-id="element-78" data-mp="sl0if4bl4u3y">
                    {f.question}
                    <PlusIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-79" data-mp="6rgdntup5wfe" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-80" data-mp="3t0hhho62th8c">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-81" data-mp="1sv95i8ewql5">
                      <p className="pb-5 leading-relaxed text-cream-muted" data-id="element-82" data-mp="1pojoaxxd2y04">{f.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}